import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Product } from './app.models';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { Guid } from "guid-typescript";
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Observable } from 'rxjs';
import { AngularDeviceInformationService } from 'angular-device-information';
import { Router } from '@angular/router';
export class Data {
    constructor(
        public cartList: Product[],
        public totalPrice: number,
        public selectedIMG: any[],
        public productIMG: any,
        public storeproductIMG: any,
        public variantIMG: any,
        public storeLogo: any,
        public CompanyLogo: any,
        public CompanyMobileLogo: any,
        public BrandIMG: any,
        public BrandMobileIMG: any,
        public CategoryIMG: any,
        public StoreListingTypeIMG: any,
        public BannerDetail: any,
        public FlyerDetail: any,
        public StoreImgDetails: any,
        public AttributeIMG: any,
        public FlyerIMG: any,
        public storeImages: any,
        public BusinessTypeIMG: any,

        public BranchIMG: any,
        public user_id: any,
        public role_id: any,
        public user_name: any,
        public user_details: any,
        public vendor_register: boolean,
        public CategoryMobileImg: any,
        public storeLongLogo: any,
        public favicon: any,
        public AppAnnouncementIMG: any,
        public DeliveryProfile: any,
        public VendorStoreImage: any,
        public OfferTypeImg: any,
        public OfferImg: any,
        public StockInterval: any,
        public CustomerAppImg: any,
        public DeliveryModuleIMG: any,
        public AdminAppIMG: any,
        public OgImage: any,
        public company_details: any,
        public company_is_global_inventory: any,
        public mobile_digit: any,
        public currency_code: any,
        public company_log: any,
        public tenant_id: any,
    ) { }


}

@Injectable()
export class AppService {

    public Data = new Data(
        [],  // cartList
        null, //totalPrice,
        [],//selected images
        [],//product image
        [],//product image
        [],//company image
        [],//company image
        [],//variant image
        [],//brand image
        [],//category image
        [],//store listing type image
        [],//attribute image
        [],//banner detail
        [],//Fyer detail
        [],// Store Image Details
        [],//store image
        [],//flyer image
        [],//flyer image
        [],//store images
        [],//store images
        [],//Branch Logo image
        0,//user_id
        0,//role_id
        null, //user_name
        [],//user_details
        false,//vendor_register
        [],//CategoryMobileImg
        [],//storeLongLogo
        [],//product image
        [],//AppAnnouncementIMG image
        [],//DeliveryProfile
        [],//vendor store image
        [],//OfferTypeImg
        [],//OfferImg
        [],//StockInterval
        [],//CustomerAppImg
        [],//DeliveryModuleIMG
        [],//AdminAppIMG
        [],// OgImage
        [],//Company details

        0,
        0,
        null,
        null,
        0
    )
    public pagetitle = new EventEmitter<any>();
    public islogin: boolean = false;
    public isLoading: boolean = true;
    public isSellerloginbtn: boolean = false;
    public url = "assets/data/";
    /*   public ecomUrl="ng serve"; */
    public ecomUrl = "http://localhost:8000/api";
    private appConfig: any;
    public storeUrl = "";
    public notification_count: any;
    public headers: any = null;
    public unique_id: Guid;
    public macaddress = '';
    ipAddress = '';

    constructor(public http: HttpClient, public snackBar: MatSnackBar, protected localStorage: LocalStorage, private angularFireMessaging: AngularFireMessaging, private deviceInformationService: AngularDeviceInformationService, public router: Router,) {
        this.unique_id = Guid.create();
        this.loadAppConfig();
        this.getIPAddress();

    }
    getIPAddress() {
        this.http.get("//api.ipify.org/?format=json").subscribe((res: any) => {
            this.ipAddress = res.ip;

        });
    }

    public getJSON(): Observable<any> {
        return this.http.get("./assets/config.json");
    }

    public isMobile() {
        return window.innerWidth < 768 || window.innerHeight < 600;
    }

    loadAppConfig() {
        this.getJSON().subscribe(data => {
            this.appConfig = data;
            this.ecomUrl = this.appConfig.apiBaseUrl;
            this.storeUrl = this.appConfig.storeUrl;
            this.localStorage.getItem('user_details').subscribe((data: any) => {
                if (data) {

                    this.Data.user_details = data;
                    this.Data.user_id = this.Data.user_details.company_users_id;
                    this.Data.role_id = this.Data.user_details.user_role_id;
                    this.Data.user_name = this.Data.user_details.user_name;
                    this.headers = new HttpHeaders().set('Authorization', 'Bearer  ' + this.Data.user_details.token);
                    this.islogin = true;
                    this.isSellerloginbtn = false;
                    this.getUnreadNotifications().subscribe(data => {

                        this.notification_count = data.length > 0 ? data.length : '';
                    });

                    this.isLoading = false;

                } else {
                    this.islogin = false;
                    this.isLoading = false;
                }

            });
            this.getcompanyDetails();
        });

    }

    getcompanyDetails() {
        this.getAllCompany().subscribe(data => {
            if (data.length > 0) {

                this.Data.company_details = data[0];
                this.Data.company_is_global_inventory = this.Data.company_details.is_global_inventory;
                this.Data.mobile_digit = this.Data.company_details.mobile_digit;
                this.Data.currency_code = this.Data.company_details.currency_code;
                this.Data.company_log = this.Data.company_details.Medium;
                this.Data.tenant_id = this.Data.company_details.tenant_id;

            }
        })
    }
    public refresh(): void {
        window.location.reload();
    }
    public getUserIdFromWebStorage() {
        this.localStorage.getItem('user_id').subscribe((data) => {
        });
    }
    public deviceRegistration(data): Observable<any> {

        return this.http.post<any>(this.ecomUrl + '/register_notification_device', data, { headers: this.headers });
    }
    public signOut() {
        this.localStorage.clear().subscribe(() => {

            this.deleteFCMtoken().subscribe(data => {
                this.headers = null;
                this.refresh();
                this.islogin = false;
            }, error => {
                //  Admin portal should logout when token expired
                if (error.error.status) {
                    this.headers = null;
                    this.refresh();
                    this.islogin = false;
                }
            })
        });
    }
    deleteFCMtoken() {
        const user_data = {
            "customer_id": this.Data.user_id,
            "role_id": this.Data.role_id,
            "app_type_id": 4,
            "user_ip": this.ipAddress,
            "os": this.deviceInformationService.getDeviceInfo().os,
            "browser": this.deviceInformationService.getDeviceInfo().browser,
            "location": 0,
            "unique_device_id": this.ipAddress,
        }
        return this.http.post<any>(this.ecomUrl + '/delete_cust_device', user_data, { headers: this.headers });
    }
    updateNotificationStatus() {
        this.http.get("//api.ipify.org/?format=json").subscribe((res: any) => {
            this.ipAddress = res.ip;
        });
        return this.http.get<any>(this.ecomUrl + '/user_notification?user_id=' + this.Data.user_id + '&role_id=' + this.Data.role_id + '&unique_device_id=' + this.ipAddress, { headers: this.headers });

    }
    //======================== DASHBOARD DETAILS START============================================
    // CUSTOMER FOR GRAPH
    public getCustomerForGraph(role_id, user_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/graphforcustomer?role_id=' + role_id + '&user_id=' + user_id, { headers: this.headers });
    }

    //TOP PRODUCTS
    public getTopProductsHome(role_id, user_id, page_first_result, result_per_page,): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/fastmovingpdt?role_id=' + role_id + '&user_id=' + user_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public getTopProducts(role_id, user_id, from_date, to_date, page_first_result, result_per_page, store_id, searchText, category_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/fastmovingpdt?role_id=' + role_id + '&user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&store_id=' + store_id + '&searchText=' + searchText + '&category_id=' + category_id, { headers: this.headers });
    }
    //TOP Stores
    public getTopStores(role_id, user_id, date_range_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/topstores?role_id=' + role_id + '&user_id=' + user_id + '&date_range_id=' + date_range_id, { headers: this.headers });
    }
    public getAllTopStores(role_id, user_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/topallstores?role_id=' + role_id + '&user_id=' + user_id, { headers: this.headers });
    }
    //======================== DASHBOARD DETAILS END============================================
    // WORKING DAYs
    public getAllWorkingDays(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/working_days', { headers: this.headers });
    }
    // COUNTRY
    public getAllCountries(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/country', { headers: this.headers });
    }
    public getAllCountriesByCompanySettings(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/country?reference_type_id=6', { headers: this.headers });
    }
    public getAllStates(country_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/state?country_id=' + country_id, { headers: this.headers });
    }
    public getAllZones(country_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/zone?country_id=' + country_id, { headers: this.headers });
    }
    //ROUNDINGS
    public getDecimalRounds(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/decimal_rounding', { headers: this.headers });
    }
    // CATEGORY SEO
    public getAllCategorySeo(category_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/seo/category/' + category_id, { headers: this.headers });
    }
    public updateCategorySeo(category_id, category): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/seo/category/' + category_id, category, { headers: this.headers });
    }

    public updatePaymentMethodStatus(payment_method_id: number, is_active: boolean): Observable<any> {
        return this.http.put<any>(
            this.ecomUrl + '/payment-method-update',
            {
                payment_method_id: payment_method_id,
                is_active: is_active
            },
            { headers: this.headers }
        );
    }
    // PRODUCT SEO
    public getAllProductSeo(product_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/seo/product/' + product_id, { headers: this.headers });
    }
    public updateProductSeo(product_id, product): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/seo/product/' + product_id, product, { headers: this.headers });
    }
    // STORE SEO
    public getAllStoreSeo(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/seo/store/' + store_id, { headers: this.headers });
    }
    public updateStoreSeo(store_id, stores): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/seo/store/' + store_id, stores, { headers: this.headers });
    }

    // COMPANY SEO
    public getAllSeoCompany(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/seo/company', { headers: this.headers });
    }
    public updateSeoCompany(company): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/seo/company', company, { headers: this.headers });
    }

    //COMPANY
    public getAllCompany(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/company', { headers: this.headers });
    }
    public updateCompany(company_id, company): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/company/' + company_id, company, { headers: this.headers });
    }
    public deleteImageFromCompany(company_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/company?company_id=' + company_id + '&resource_id=' + resource_id, { headers: this.headers });
    }
    public deleteMobileLogoFromCompany(company_id, mobile_logo): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/company?company_id=' + company_id + '&mobile_logo=' + mobile_logo, { headers: this.headers });
    }
    public deletefavicon(company_id, favicon): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/company?company_id=' + company_id + '&favicon=' + favicon, { headers: this.headers });
    }
    public deleteCustomerAppImg(company_id, customer_splash): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/companies?company_id=' + company_id + '&customer_splash=' + customer_splash, { headers: this.headers });
    }
    public deleteOgimage(company_id, og_image): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/companies?company_id=' + company_id + '&og_image=' + og_image, { headers: this.headers });
    }
    public deleteDelivery_module(company_id, delivery_module): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/companies?company_id=' + company_id + '&delivery_module=' + delivery_module, { headers: this.headers });
    }
    public deleteAdminApp(company_id, admin_splash): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/companies?company_id=' + company_id + '&admin_splash=' + admin_splash, { headers: this.headers });
    }
    public getBannerUrlType(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/banner_url_type', { headers: this.headers });
    }
    public getQRUrlType(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/qr_url_type', { headers: this.headers });
    }
    // CURRENCY
    public getAllCurrency(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/currency', { headers: this.headers });
    }
    public getAllCurrencyByCountry(country_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/currency?country_id=' + country_id, { headers: this.headers });
    }
    // LANGUAGE
    public getAllLanguage(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/language', { headers: this.headers });
    }
    //AREA
    public getAllArea(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/area', { headers: this.headers });
    }
    public getAllAreawithlimit(page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/area?page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public getAllAreaByState(state_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/area?state_id=' + state_id, { headers: this.headers });
    }
    public getAllAreaByCountry(country_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/area?country_id=' + country_id, { headers: this.headers });
    }
    public createArea(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/area', data, { headers: this.headers });
    }
    public updateArea(area_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/area/' + area_id, data, { headers: this.headers });
    }
    // deposits
    public getAllDeposits(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/deposits', { headers: this.headers });
    }
    public createDeposits(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/deposits', data, { headers: this.headers });
    }
    public updateDeposits(deposit_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/deposits/' + deposit_id, data, { headers: this.headers });
    }
    // TAX
    public getAllTax(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/tax', { headers: this.headers });
    }
    public getTax(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/tax?store_id=' + store_id, { headers: this.headers });
    }
    public createTax(taxs): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/tax', taxs, { headers: this.headers });
    }
    public updateTax(tax_id, taxs): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/tax/' + tax_id, taxs, { headers: this.headers });
    }
    public deleteTax(tax_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/tax/' + tax_id, { headers: this.headers });
    }
    // SESSIONS 03-09-2020
    public getAllSessions(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session', { headers: this.headers });
    }

    public getAllSessionsByStore(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session?store_id=' + store_id, { headers: this.headers });
    }

    public getAllSessionsByListingType(listing_type): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session?listing_type=' + listing_type, { headers: this.headers });
    }

    public createSession(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/session', data, { headers: this.headers });
    }
    public updateSession(session_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/session/' + session_id, data, { headers: this.headers });
    }

    public updateSessionStatus(session_id, is_active): Observable<any> {
        const data = { session_id: session_id, is_active: is_active };
        return this.http.put<any>(this.ecomUrl + '/update-session-status', data, { headers: this.headers });
    }


    public deleteSession(session_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/session/' + session_id, { headers: this.headers });
    }

    // SESSION SETTINGS 03-09-2020
    public createSessionSettings(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/session_settings', data, { headers: this.headers });
    }
    public getAllSessionSettings(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session_settings?store_id=' + store_id, { headers: this.headers });
    }
    public getStoreSession(store_id, reservation_date): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session_settings?store_id=' + store_id + '&date=' + reservation_date, { headers: this.headers });
    }
    public getSessionSettingsById(session_settings_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session_settings?session_settings_id=' + session_settings_id, { headers: this.headers });
    }
    // public getStoreSessionTime(store_id, session_id, working_day): Observable<any[]> {
    //     return this.http.get<any[]>(this.ecomUrl + '/session_settings?store_id=' + store_id + '&session_id=' + session_id + '&working_day=' + working_day, { headers: this.headers });
    // }
    public getStoreSessionTime(store_id, working_day): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/session_settings?store_id=' + store_id + '&working_day=' + working_day, { headers: this.headers });
    }
    public updateSessionSettings(session_settings_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/session_settings/' + session_settings_id, data, { headers: this.headers });
    }
    public deleteSessionSettings(session_settings_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/session_settings/' + session_settings_id, { headers: this.headers });
    }
    // SHIFT
    public getAllShift(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/shift', { headers: this.headers });
    }

    public getCancelItemReport(
        store_id: number,
        from_date: string,
        to_date: string,
        page_first_result: number,
        result_per_page: number
    ): Observable<any[]> {
        const params =
            '?store_id=' + encodeURIComponent(String(store_id)) +
            '&from_date=' + encodeURIComponent(from_date) +
            '&to_date=' + encodeURIComponent(to_date) +
            '&page_first_result=' + encodeURIComponent(String(page_first_result)) +
            '&result_per_page=' + encodeURIComponent(String(result_per_page));
        return this.http.get<any[]>(this.ecomUrl + '/cancelled-item-report' + params, { headers: this.headers });
    }

    public exportOrderItems(store_id: number, from_date: string, to_date: string): Observable<any> {
        const params =
            '?store_id=' + encodeURIComponent(String(store_id)) +
            '&from_date=' + encodeURIComponent(from_date) +
            '&to_date=' + encodeURIComponent(to_date);
        return this.http.get<any>(this.ecomUrl + '/export-order-items' + params, { headers: this.headers });
    }


    public getAllShiftByStoreID(store_id: number, date: string): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store-shifts?store_id=' + store_id + '&date=' + encodeURIComponent(date), { headers: this.headers });
    }

    public getAllShiftByStore(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/shift?store_id=' + store_id, { headers: this.headers });
    }
    public createShift(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/shift', data, { headers: this.headers });
    }
    public updateShift(shift_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/shift/' + shift_id, data, { headers: this.headers });
    }
    // STORE SHIFT
    public getAllStoreShift(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store_shift?store_id=' + store_id, { headers: this.headers });
    }
    public createStoreShift(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store_shift', data, { headers: this.headers });
    }
    public updateStoreShift(store_shift_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_shift/' + store_shift_id, data, { headers: this.headers });
    }

    //TABLE RESERVATION 04-09-2020
    public createTableReservation(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/reservation_table', data, { headers: this.headers });
    }
    public getTableReservation(store_id, page_first_result, result_per_page, searchText): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reservation_table?store_id=' + store_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&searchText=' + searchText, { headers: this.headers });
    }

    public updateTableReservation(reservation_table_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/reservation_table/' + reservation_table_id, data, { headers: this.headers });
    }
    // STORE ATTRIBUTE 05-09-2020
    public createStoreAttribute(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store_attribute', data, { headers: this.headers });
    }
    public getStoreAttribute(store_id): Observable<any> {
        return this.http.get<any[]>(this.ecomUrl + '/store_attribute?store_id=' + store_id, { headers: this.headers });
    }
    public deleteStoreAttribute(store_attribute_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store_attribute/' + store_attribute_id, { headers: this.headers });
    }

    // STORE WORKING TIME 31-10-2020
    public createStoreWorkingTime(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store_working', data, { headers: this.headers });
    }
    public getStoreWorkingTime(store_id): Observable<any> {
        return this.http.get<any[]>(this.ecomUrl + '/store_working?store_id=' + store_id, { headers: this.headers });
    }
    public getStoreWorkingTimesById(store_work_tm_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store_working?store_work_tm_id=' + store_work_tm_id, { headers: this.headers });
    }
    public updateStoreWorkingTime(store_work_tm_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_working/' + store_work_tm_id, data, { headers: this.headers });
    }
    public deleteStoreWorkingTime(store_work_tm_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store_working/' + store_work_tm_id, { headers: this.headers });
    }

    // STORE HOLIDAY TIME 02-11-2020
    public createStoreHoliday(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store_holiday', data, { headers: this.headers });
    }
    public getStoreHoliday(store_id): Observable<any> {
        return this.http.get<any[]>(this.ecomUrl + '/store_holiday?store_id=' + store_id, { headers: this.headers });
    }
    public updateStoreHoliday(store_holiday_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_holiday/' + store_holiday_id, data, { headers: this.headers });
    }
    public deleteStoreHoliday(store_holiday_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store_holiday/' + store_holiday_id, { headers: this.headers });
    }
    public deleteUnit(unit_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/unit/' + unit_id, { headers: this.headers });
    }
    public deleteTable(table_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/tables/' + table_id, { headers: this.headers });
    }
    // RESOURCE TYPES
    public getResourceTypes(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/resource_type', { headers: this.headers });
    }
    public getResourceTypeForCompanyBanner(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/resource_type?companyBanner=1', { headers: this.headers });
    }
    public getResourceTypeForStoreBanner(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/resource_type?storeBanner=1', { headers: this.headers });
    }
    public getResourceTypesById(resource_type_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/resource_type?resource_type_id=' + resource_type_id, { headers: this.headers });
    }
    public getPaymentMethod(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/payment_method', { headers: this.headers });
    }
    public getPaymentMethodAll(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/payment_method?listing_type=all', { headers: this.headers });
    }

    // REFERENCE TYPES
    public getReferenceTypes(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type', { headers: this.headers });
    }
    // ORDER OPTIONS
    public getOrderOptions(listing_type: string): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/order_options?listing_type=' + listing_type, {
            headers: this.headers,
        });
    }

    public updateOrderOption(order_option_id: number, is_active: number): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/update-order-option', {
            order_option_id: order_option_id,
            is_active: is_active
        }, { headers: this.headers });
    }

    public createStorePayment(pay_method_id: number, app_type_id: number, store_id: number, is_active: number): Observable<any> {
        const body = {
            pay_method_id: pay_method_id,
            app_type_id: app_type_id,
            store_id: store_id,
            is_active: is_active
        };
        return this.http.put<any>(this.ecomUrl + '/create-store-payment', body, { headers: this.headers });
    }






    public getReferenceTypesforAttribute(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?attribute', { headers: this.headers });
    }
    public getReferenceTypesforOffer(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?offer', { headers: this.headers });
    }
    public getReferenceTypesforFooter(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?footer', { headers: this.headers });
    }
    public getReferenceTypesforSearch(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?search', { headers: this.headers });
    }
    public getReferenceTypesforSubscription(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?subscription', { headers: this.headers });
    }
    public getReferenceTypesforSlug(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?slug', { headers: this.headers });
    }
    public getReferenceTypesforOrder(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?order', { headers: this.headers });
    }
    public getReferenceTypesforBanner(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?banner', { headers: this.headers });
    }
    public getSubscriptionPlans(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/subscription_plans', { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    //====================================== VENDOR=====================================
    // ---------------------------------------------------------------------------------------
    public approvedVendor(vendor_id, vendor): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/vendor_approvel/' + vendor_id, vendor, { headers: this.headers });
    }

    public blacklistedVendor(vendor_id, vendor): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/vendor_blacklisted/' + vendor_id, vendor, { headers: this.headers });
    }
    public OfferVerify(prod_offer_id, offer_verify): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/offer_approvel/' + prod_offer_id, offer_verify, { headers: this.headers });
    }
    public getAllVendors(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/vendor', { headers: this.headers });
    }
    public getAllVerifiedVendors(user_id, role_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/verified_vendor?user_id=' + user_id + '&role_id=' + role_id, { headers: this.headers });
    }
    public getVendorDetails(user_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/vendorbyid?user_id=' + user_id, { headers: this.headers });
    }
    // ------------------------------------------------------------------------------------------------
    // ====================STORES ====================
    // ------------------------------------------------------------------------------------------------
    public getStoreDetails(store_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/store?store_id=' + store_id, { headers: this.headers });
    }
    public getAllStores(user_id, role_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store?role_id=' + role_id + '&user_id=' + user_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public getStores(user_id, role_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/store?role_id=' + role_id + '&user_id=' + user_id + '&Admin', { headers: this.headers });
    }

    public CreateStores(stores): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store', stores, { headers: this.headers });
    }

    public getPickupLocationBystore_id(store_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/store?store_id=' + store_id, { headers: this.headers });
    }
    public deleteImageFromStore(store_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/store?store_id=' + store_id + '&resource_id=' + resource_id, { headers: this.headers });
    }

    public deleteStoreLongImage(store_id, store_long_logo): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/store?store_id=' + store_id + '&store_long_logo=' + store_long_logo, { headers: this.headers });
    }
    public deleteProfileImage(delivery_agent_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/delivery_agent?delivery_agent_id=' + delivery_agent_id, { headers: this.headers });
    }
    public deleteOfferImage(prod_offer_type_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/delete_img_offer_type?prod_offer_type_id=' + prod_offer_type_id, { headers: this.headers });
    }

    public updateStores(store_id, stores): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store/' + store_id, stores, { headers: this.headers });
    }
    public deleteStores(store_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store/' + store_id, { headers: this.headers })
    }
    public premiumStore(store_id, store_premium): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_premium/' + store_id, store_premium, { headers: this.headers });
    }

    public reviewStatus(prod_rev_id, review_status): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/product_review_status/' + prod_rev_id, review_status, { headers: this.headers });
    }
    public StorereviewStatus(store_rev_id, review_status): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_review/' + store_rev_id, review_status, { headers: this.headers });
    }

    public deleteStoreImage(store_id, resource_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store_image/' + resource_id, { headers: this.headers })
    }
    // ------------------------------------------------------------------------------------------------
    // ====================PICKUP LOCATION ====================
    // ------------------------------------------------------------------------------------------------
    public createLocation(pickup): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/pickup_location', pickup, { headers: this.headers });
    }
    public getPickupLocationsBystore(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/pickup_location', { headers: this.headers });
    }
    // public getPickupLocations(store_id): Observable<any[]> {
    //     return this.http.get<any[]>(this.ecomUrl + '/pickup_location?store_id' + store_id, {headers:this.headers});
    // }
    public updateLocation(pickup_id, pickup): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/pickup_location/' + pickup_id, pickup, { headers: this.headers });
    }
    // ------------------------------------------------------------------------------------------------
    //  ====================BusinessType====================
    // ------------------------------------------------------------------------------------------------
    public createBusinessType(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/business_type', data, { headers: this.headers });
    }
    public getAllBusinessType(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/business_type?is_verified=' + 1, { headers: this.headers });
    }

    public getBusinessTypesByListingType(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/business_type?listing_type=All', { headers: this.headers });
    }

    public approvedBusinessType(business_type_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/business_type_approvel/' + business_type_id, data, { headers: this.headers });
    }

    public createSubBusinessType(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/sub_business_type', datas, { headers: this.headers });
    }
    public deleteImageFromBusinessType(business_type_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/business_type?business_type_id=' + business_type_id + '&resource_id=' + resource_id, { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    // ==================== BRANCHES ====================
    // ------------------------------------------------------------------------------------------------
    public deleteImageFromBranch(branch_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/store_branches?branch_id=' + branch_id + '&resource_id=' + resource_id, { headers: this.headers });
    }
    public CreateBranches(branch): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/store_branches', branch, { headers: this.headers });
    }
    public getStoreBranches(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store_branches?store_id=' + store_id, { headers: this.headers });
    }
    public deleteBranch(branch_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/store_branches/' + branch_id, { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    // ==================== COMPATIBILITY ====================
    // ------------------------------------------------------------------------------------------------
    public getCompatibilityCategories(store_id: any, category_id: any = 0): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/compatibility-categories?store_id=${store_id}&category_id=${category_id}`, { headers: this.headers });
    }

    public getCompatibilityProducts(store_id: any, category_id: any, page_first_result: any, result_per_page: any, target_category_id: any = 0): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/compatibility-products?store_id=${store_id}&category_id=${category_id}&page_first_result=${page_first_result}&result_per_page=${result_per_page}&target_category_id=${target_category_id}`, { headers: this.headers });
    }

    public saveCompatibility(product_id: any, compatible_products: any[]): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/compatibile-products/${product_id}`, { product_id, compatible_products }, { headers: this.headers });
    }

    public deleteCompatibility(product_id_1: any, product_id_2: any): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/compatibile-products/delete`, { product_id_1, product_id_2 }, { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    // ==================== PLUGINS ====================
    // ------------------------------------------------------------------------------------------------
    public getPlugins(): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/plugins`, { headers: this.headers });
    }

    public updatePluginStatus(plugin_id: any, data: any): Observable<any> {
        return this.http.put<any>(`${this.ecomUrl}/plugins/${plugin_id}`, data, { headers: this.headers });
    }

    public getPcBuilderConfiguration(): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/pc-builder/configure`, { headers: this.headers });
    }

    public savePcBuilderConfiguration(data: any): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/pc-builder/configure`, data, { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    // ==================== PRODUCT SPECIFICATIONS ====================
    // ------------------------------------------------------------------------------------------------
    public getSpecifications(store_id: any): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/specifications/details?store_id=${store_id}`, { headers: this.headers });
    }

    public createSpecification(data: any): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/specifications`, data, { headers: this.headers });
    }

    public updateSpecification(spec_id: number, data: any): Observable<any> {
        return this.http.put<any>(`${this.ecomUrl}/specifications/${spec_id}`, data, { headers: this.headers });
    }

    public createSpecValue(data: any): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/spec-values`, data, { headers: this.headers });
    }

    public addProductSpecification(data: any): Observable<any> {
        return this.http.post<any>(`${this.ecomUrl}/product-specifications`, data, { headers: this.headers });
    }

    public getProductSpecifications(product_id: any): Observable<any> {
        return this.http.get<any>(`${this.ecomUrl}/product-specifications/${product_id}`, { headers: this.headers });
    }
    public updateBranch(branch_id, branch): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_branches/' + branch_id, branch, { headers: this.headers });
    }

    // ------------------------------------------------------------------------------------------------
    //  ====================SLOTS====================
    // ------------------------------------------------------------------------------------------------
    public getAllSlots(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/slots?store_id=' + store_id, { headers: this.headers });
    }
    public getAllSlotsForAdmin(user_id, role_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/slots?user_id=' + user_id + '&role_id=' + role_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getdeliverySlotsByDate(working_day, store_id, date): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/slots?working_day=' + working_day + '&store_id=' + store_id + '&date=' + date, { headers: this.headers });
    }
    public getdeliverySlots(working_day, store_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/slots?working_day=' + working_day + '&store_id=' + store_id, { headers: this.headers });
    }
    public getPickupSlots(weekday, store_id, date): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/slots?weekday=' + weekday + '&store_id=' + store_id + '&date=' + date, { headers: this.headers });
    }
    public orderPickupSlotChange(prod_order_id, orderslot): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/orderpickupslot/' + prod_order_id, orderslot, { headers: this.headers });
    }
    public createWorkDelivery(delivery): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/delivery_slot', delivery, { headers: this.headers });
    }
    public deleteDeliverySlots(store_id, working_day, session_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/delivery_slot?store_id=' + store_id + '&working_day=' + working_day + '&session_id=' + session_id, { headers: this.headers });
    }
    public getDeliverySlotById(store_del_slot_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/delivery_slot?store_del_slot_id=' + store_del_slot_id, { headers: this.headers });
    }
    public updateDeliverySlot(store_del_slot_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/delivery_slot/' + store_del_slot_id, data, { headers: this.headers });
    }
    // public deleteSlots(working_day): Observable<any> {
    //     return this.http.delete<any>(this.ecomUrl + '/storeworking/' + working_day, { headers: this.headers })
    // }
    public deleteDeliverySlot(store_del_slot_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/delivery_slot/' + store_del_slot_id, { headers: this.headers })
    }
    public createWorkPickup(pickup): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/pickupslot', pickup, { headers: this.headers });
    }
    public getAllPickupSlotsForAdmin(user_id, role_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/pickupslot?user_id=' + user_id + '&role_id=' + role_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public deletePickupSlots(store_id, working_day): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/pickupslot?store_id=' + store_id + '&working_day=' + working_day, { headers: this.headers });
    }
    // ------------------------------------------------------------------------------------------------
    //  ====================FLYER ====================
    // ------------------------------------------------------------------------------------------------
    public deleteImageFromFlyer(store_flyer_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/store_flyer_img?reference_id=' + store_flyer_id + '&resource_id=' + resource_id, { headers: this.headers });
    }
    public updateFlyer(store_flyer_id, flyer): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/store_flyer/' + store_flyer_id, flyer, { headers: this.headers });
    }
    // ------------------------------------------------------------------------------------------------
    //  ====================COUPONS ====================
    // ------------------------------------------------------------------------------------------------
    public deleteAssignCoupon(coupon_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/assign_coupon/' + coupon_id, { headers: this.headers })
    }
    //Coupon
    public deleteCoupon(coupon_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/coupon/' + coupon_id, { headers: this.headers })
    }
    public updateCoupon(coupon_id, coupon): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/coupon/' + coupon_id, coupon, { headers: this.headers });
    }
    // ------------------------------------------------------------------------------------------------
    //  ====================ORDERS ====================
    // ------------------------------------------------------------------------------------------------
    public getproductOrder(from_date, to_date, store_id, filter_id, order_status_id, page_first_result, result_per_page, pay_method_id, waiter_id, payment_status_id, del_agent_id, kiosk_id, shift_id, order_filter_id, delivery_partner_id, order_option_id, cashier_id, reference_type_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/productorder?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&filter_id=' + filter_id + '&order_status_id=' + order_status_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&pay_method_id=' + pay_method_id + '&waiter_id=' + waiter_id + '&payment_status_id=' + payment_status_id + '&del_agent_id=' + del_agent_id + '&kiosk_id=' + kiosk_id + '&shift_id=' + shift_id + '&order_filter_id=' + order_filter_id + '&delivery_partner_id=' + delivery_partner_id + '&order_option_id=' + order_option_id + '&cashier_id=' + cashier_id + '&reference_type_id=' + reference_type_id, { headers: this.headers });
    }
    public getOrderForAgent(from_date, to_date, store_id, page_first_result, result_per_page, searchText): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/productorder?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&agent=1&search_text=' + searchText, { headers: this.headers });
    }

    // -----------------------------------------------------------------------------------------
    // ===============================Return Requests===========================================
    // -----------------------------------------------------------------------------------------
    public getRetReQ(from_date, to_date, page_first_result, result_per_page,): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/return-requests?from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public returnAssignment(data) {
        return this.http.post<any>(this.ecomUrl + '/return-assignments', data, { headers: this.headers });
    }
    // -----------------------------------------------------------------------------------------
    // ================================END======================================================
    // -----------------------------------------------------------------------------------------

    public orderUpdate(prod_order_id, order): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/productorder/' + prod_order_id, order, { headers: this.headers });
    }

    public deleteOrder(prod_order_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/productorder/' + prod_order_id, { headers: this.headers });
    }
    public getOrderitemId(order_item_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/productbyorderitemid?order_item_id=' + order_item_id, { headers: this.headers });
    }
    public getOrderItems(prod_order_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/productorderitem?prod_order_id=' + prod_order_id, { headers: this.headers });
    }
    public getOrderItemByItemID(order_item_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/productorderitem?order_item_id=' + order_item_id, { headers: this.headers });
    }
    public getOrdersItemsByProductId(product_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/productorderitem?product_id=' + product_id, { headers: this.headers });
    }
    public getOrderItembyOrderID(prod_order_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/productorderitem/' + prod_order_id, { headers: this.headers });
    }



    public deleteOrderItem(order_item_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/productorderitem/' + order_item_id, { headers: this.headers });
    }
    public onShippingFormSubmit(shipdata): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/customershippingaddress', shipdata, { headers: this.headers });
    }
    public orderAddressChange(prod_order_id, order): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/orderaddress/' + prod_order_id, order, { headers: this.headers });
    }
    // party order edit customer address
    public onCustomerPartyOrderFormSubmit(party_order_id, shipdata): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/party_order/editaddress/' + party_order_id, shipdata, { headers: this.headers });
    }
    public orderSlotChange(prod_order_id, orderitem): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/orderslot/' + prod_order_id, orderitem, { headers: this.headers });
    }
    public getCustomerShippingAddress(cust_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/customershippingaddress?cust_id=' + cust_id, { headers: this.headers });
    }
    public getAllBrandsByStoreID(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/brand?sort=asc&store_id=' + store_id, { headers: this.headers });
    }
    public deleteShippAddress(cust_ship_address_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/customershippingaddress/' + cust_ship_address_id, { headers: this.headers });
    }

    //ORDER

    // get ORDER HISTORY BY NEETHU JUN 11 2019
    public getOrderHistory(prod_order_id) {
        return this.http.get<any[]>(this.ecomUrl + '/order_history?prod_order_id=' + prod_order_id, { headers: this.headers });
    }
    //get deliveryboys by neethu May 23 2019
    public getDeliveryBoys(store_id) {
        return this.http.get<any[]>(this.ecomUrl + '/deliveryboys?store_id=' + store_id, { headers: this.headers });
    }
    //order assignment by neethu May 24 2019
    public OrderAssignment(data) {
        return this.http.post<any>(this.ecomUrl + '/order_assign', data, { headers: this.headers });
    }
    public orderStatus(store_id, order_status_name): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/orderstatus?store_id=' + store_id + '&order_status_name=' + order_status_name, { headers: this.headers });
    }
    public deliveryMethod(store_id, del_method): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/deliverymethod?store_id=' + store_id + '&del_method=' + del_method, { headers: this.headers });
    }
    public deliveryMethodFilter(): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/deliverymethod', { headers: this.headers });
    }
    //  ====================order details ====================
    public getOrderDetailsbyProductName(store_id, product_name, from_date, to_date, delivery_date, service_id, cust_id, slot, category_id, payment_status_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/order_details?store_id=' + store_id + '&product_name=' + product_name + '&from_date=' + from_date + '&to_date=' + to_date + '&delivery_date=' + delivery_date + '&service_id=' + service_id + '&cust_id=' + cust_id + '&slot=' + slot + '&category_id=' + category_id + '&payment_status_id=' + payment_status_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public getOrderDetailsbyOrderNo(store_id, order_number, from_date, to_date, delivery_date, service_id, cust_id, slot, category_id, payment_status_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/order_details?store_id=' + store_id + '&order_number=' + order_number + '&from_date=' + from_date + '&to_date=' + to_date + '&delivery_date=' + delivery_date + '&service_id=' + service_id + '&cust_id=' + cust_id + '&slot=' + slot + '&category_id=' + category_id + '&payment_status_id=' + payment_status_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    //  ====================Return Items ====================
    public getOrdersByStoreIdsearch(store_id, from_date, to_date, page_first_result, result_per_page, searchText): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/orderreturns?&store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&searchText=' + searchText, { headers: this.headers });
    }
    public getOrdersByStoreId(store_id, from_date, to_date, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/orderreturns?&store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public returnItem(returnitems): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/return-requests/store', returnitems, { headers: this.headers });
    }
    public searchCustomerByDateInReturnItem(from_date, to_date, store_id, cust_name): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/returnitemreport?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&cust_name=' + cust_name, { headers: this.headers });
    }

    //  =================================Product ==================================
    public deleteVariant(prod_var_code): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/productvariant?prod_var_code=' + prod_var_code, { headers: this.headers });
    }
    public getProduct(cust_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product?cust_id=' + cust_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getProductbyId(product_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product?product_id=' + product_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getProductbyProductId(product_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product/' + product_id, { headers: this.headers });
    }
    public getProductRowCount(): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/product?product_rowcount', { headers: this.headers });
    }

    public getProductRowCountByStoreID(store_id): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/product?product_rowcount&store_id=' + store_id, { headers: this.headers });
    }
    //  ====================Categories ====================
    //CATEGORY==>
    public createCategory(category): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/category', category, { headers: this.headers });
    }
    public getAllCategories(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/category', { headers: this.headers });
    }
    public getAllCategoriesByStoreID(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/category?sort=asc&store_id=' + store_id, { headers: this.headers });
    }
    public getCategoriesforAdmin(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/category?Admin&store_id=' + store_id, { headers: this.headers });
    }
    public getCategoryByStoreID(store_id, session_id, this_page_first_item, result_per_page, searchText, is_premium?, is_featured?, is_hide?, is_pre_order?, has_sub_category?, is_super_category?, is_purchasable?): Observable<any[]> {
        let url = this.ecomUrl + '/category?store_id=' + store_id + '&session_id=' + session_id + '&page_first_result=' + this_page_first_item + '&result_per_page=' + result_per_page + '&searchText=' + searchText;

        if (is_premium !== undefined && is_premium !== '') {
            url += '&is_premium=' + is_premium;
        }
        if (is_featured !== undefined && is_featured !== '') {
            url += '&is_featured=' + is_featured;
        }
        if (is_hide !== undefined && is_hide !== '') {
            url += '&is_hide=' + is_hide;
        }
        if (is_pre_order !== undefined && is_pre_order !== '') {
            url += '&is_pre_order=' + is_pre_order;
        }
        if (has_sub_category !== undefined && has_sub_category !== '') {
            url += '&has_sub_category=' + has_sub_category;
        }
        if (is_purchasable !== undefined && is_purchasable !== '') {
            url += '&is_purchasable=' + is_purchasable;
        }
        if (is_super_category !== undefined && is_super_category !== '') {
            url += '&is_super_category=' + is_super_category;
        }

        return this.http.get<any[]>(url, { headers: this.headers });
    }
    public deleteCategory(category_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/category/' + category_id, { headers: this.headers })
    }

    public updateCategory(category_id, category): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/category/' + category_id, category, { headers: this.headers });
    }
    public deleteMobileImageFromCategory(category_id, mobileimage_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/category?category_id=' + category_id + '&mobileimage_id=' + mobileimage_id, { headers: this.headers });
    }
    public updateCategoryRelation(category_id, categoryRelation): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/categoryrelation/' + category_id, categoryRelation, { headers: this.headers });
    }
    public getAllCategory(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/category', { headers: this.headers });
    }
    public deleteImageFromCategory(category_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/category?category_id=' + category_id + '&resource_id=' + resource_id, { headers: this.headers });
    }
    public getTagsByStore1(store_id, searchText, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/productTag?store_id=' + store_id + '&searchText=' + searchText + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public deleteImageFromStoreListingType(store_listing_type, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/store_listing?store_listing_id=' + store_listing_type + '&resource_id=' + resource_id, { headers: this.headers });
    }
    //  ====================Brands ====================
    public getBrandbyId(brand_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/brand?brand_id=' + brand_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getBrandRowCount(): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/brand?brand_rowcount', { headers: this.headers });
    }
    public getBrandWithStoreIdRowCount(store_id): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/brand?brand_rowcount' + '&store_id=' + store_id, { headers: this.headers });
    }
    public createBrand(Brands): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/brand', Brands, { headers: this.headers });

    }
    public updateBrand(brand_id, updatebrands): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/brand/' + brand_id, updatebrands, { headers: this.headers })
    }
    public getBrandsByStoreID(store_id, this_page_first_item, result_per_page,): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/brand?store_id=' + store_id + '&this_page_first_item=' + this_page_first_item + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public deleteBrand(brand_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/brand/' + brand_id, { headers: this.headers })
    }
    public premiumBrand(brand_id, brand_premium): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/brand_premium/' + brand_id, brand_premium, { headers: this.headers });
    }
    // =======================BRAND CATEGORY==================================

    public deleteBrandcategory(brand_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/brandcategory/' + brand_id, { headers: this.headers })
    }
    public createBrandcategory(insertbrandcategory): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/brandcategory', insertbrandcategory, { headers: this.headers });
    }
    public getBrandcategoryByStoreID(brand_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/brandcategory?brand_id=' + brand_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public deleteImageFromBrand(brand_id, image): Observable<any> {

        return this.http.put<any>(this.ecomUrl + '/brandcategory/' + brand_id, image, { headers: this.headers });
    }
    //  ====================Attributes ====================

    public createAttrubutes(attribute): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/attribute', attribute, { headers: this.headers });
    }
    public getAllAttributes(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attribute', { headers: this.headers });
    }
    public getAttributesforProduct(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attribute?store_id=' + store_id + '&reference_type_id=' + 3, { headers: this.headers });
    }
    public getAttributesforStore(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attribute?store_id=' + store_id + '&reference_type_id=' + 1, { headers: this.headers });
    }
    public getAllAttributename(att_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attribute?att_id=' + att_id, { headers: this.headers });
    }
    public deleteAttribute(att_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/attribute/' + att_id, { headers: this.headers });
    }
    public updateAttributes(att_id, attribute): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/attribute/' + att_id, attribute, { headers: this.headers });
    }

    public getAttributesByStoreID(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attributevalues?store_id=' + store_id, { headers: this.headers });
    }
    public getAttributeValueByAttID(att_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/attributevalues?att_id=' + att_id, { headers: this.headers });
    }
    public getAttributesByAttID(att_id, store_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/attributevalues?att_id=' + att_id + '&store_id=' + store_id, { headers: this.headers });
    }

    public getAttributeValueByID(atr_value_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/attributevalues?atr_value_id=' + atr_value_id, { headers: this.headers });
    }
    public createAttributeValues(attributevalues): Observable<any[]> {
        return this.http.post<any>(this.ecomUrl + '/attributevalues', attributevalues, { headers: this.headers });
    }
    public updateAttributeValues(atr_value_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/attributevalues/' + atr_value_id, data, { headers: this.headers });
    }

    //  ====================product Attribute ====================
    public createProductAttribute(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/product_attributes', datas, { headers: this.headers });
    }
    public getAttributeByStore(store_id, searchText, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product_attributes?store_id=' + store_id + '&searchText=' + searchText + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public updateproductAttribute(product_id, datas): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/product_attributes/' + product_id, datas, { headers: this.headers });
    }
    public deleteproductAttribute(product_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/product_attributes/' + product_id, { headers: this.headers })
    }
    //  ====================Services ====================

    public createservice(formdata): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/service', formdata, { headers: this.headers });
    }
    public getServiceByStoreID(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/service?store_id=' + store_id, { headers: this.headers });
    }
    public getGroupService(store_id, service_price): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/service?store_id=' + store_id + '&service_price=' + service_price, { headers: this.headers });
    }
    public deleteService(service_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/service/' + service_id, { headers: this.headers })
    }
    public updateService(service_id, updateservices): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/service/' + service_id, updateservices, { headers: this.headers })
    }
    //  ==================== Tags ====================
    public createTag(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/tag', data, { headers: this.headers });
    }
    public getTagsByStore(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/tag?store_id=' + store_id, { headers: this.headers });
    }
    public searchTags(searchText): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/tag?query=' + searchText + '&page_first_result=0&result_per_page=30', { headers: this.headers });
    }
    public updateTag(tag_id, updatetags): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/tag/' + tag_id, updatetags, { headers: this.headers });
    }
    public deleteTag(tag_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/tag/' + tag_id, { headers: this.headers })
    }
    //  ====================product Tags ====================
    public createProductTag(producttag): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/productTag', producttag, { headers: this.headers });
    }
    public getProductTagsByStore(store_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/productTag?store_id=' + store_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public updateproductTag(product_id, producttag): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/productTag/' + product_id, producttag, { headers: this.headers });
    }
    public deleteproductTag(product_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/productTag/' + product_id, { headers: this.headers })
    }
    //  ====================Offers ====================
    public getAllProductOfferByStoreID(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product_offer_type?sort=asc&store_id=' + store_id, { headers: this.headers });
    }
    // public getproductOffers(from_date, to_date, store_id): Observable<any[]> {
    //     return this.http.get<any[]>(this.ecomUrl + '/product_offer?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id, { headers: this.headers });
    // }
    public getproductOffers(from_date, to_date, store_id, searchText, page_first_result, result_per_page, offer_status): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/product_offer?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&searchText=' + searchText + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&offer_status=' + offer_status, { headers: this.headers });
    }
    // public getStoreproductOffers(from_date, to_date, store_id, searchText, page_first_result, result_per_page): Observable<any[]> {
    //     return this.http.get<any[]>(this.ecomUrl + '/store_product_offer?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&searchText=' + searchText + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    // }
    public getOfferbyProductId(product_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/product_offer/' + product_id, { headers: this.headers });
    }
    public updateOfferbyProductId(product_id, is_offer_product): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/product_offer?product_id=' + product_id + '&is_offer_product=' + is_offer_product, { headers: this.headers });
    }

    public deleteOfferTypes(Product_offer_type): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/product_offer_type/' + Product_offer_type, { headers: this.headers })
    }
    public updateOfferTypes(Product_offer_type_id, Product_offer_type): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/product_offer_type/' + Product_offer_type_id, Product_offer_type, { headers: this.headers })
    }


    // ====================  offers ===================================================================
    public createOffer(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/offers', data, { headers: this.headers });
    }
    public getAllOffers(page_first_result, result_per_page, reference_type_id, store_id, user_id, role_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/offers?page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&reference_type_id=' + reference_type_id + '&user_id=' + user_id + '&role_id=' + role_id, { headers: this.headers });
    }
    public updateOffer(offer_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/offers/' + offer_id, data, { headers: this.headers })
    }
    public deleteOffer(offer_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/offers/' + offer_id, { headers: this.headers })
    }
    // ====================  offer Priority  ===================================================================
    public createOfferPriority(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/offer_priority', data, { headers: this.headers });
    }
    public getOfferPriority(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/offer_priority', { headers: this.headers });
    }
    public updateOfferPriority(offer_priority_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/offer_priority/' + offer_priority_id, data, { headers: this.headers })
    }
    public deleteOfferPriority(store_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/offer_priority/' + store_id, { headers: this.headers })
    }
    // ====================  Subscription Settings  ===================================================================
    public createSubscriptionSettings(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/subscription_settings', data, { headers: this.headers });
    }
    public updateSubscriptionSettings(subscription_plan_det_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/subscription_settings/' + subscription_plan_det_id, data, { headers: this.headers })
    }
    public getSubscriptionSettings(subscription_plan_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/subscription_settings?subscription_plan_id=' + subscription_plan_id, { headers: this.headers });
    }
    // ==================== Medias ===================================================================
    public getAllImages(resource_type_id, page_first_result, result_per_page, searchText): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/media?user_id=' + this.Data.user_id + '&role_id=' + this.Data.role_id + '&resource_type_id=' + resource_type_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&searchText=' + searchText, { headers: this.headers });
    }
    public deleteImage(resourceid): Observable<any> {

        return this.http.delete<any>(this.ecomUrl + '/media/' + resourceid, { headers: this.headers })
    }
    //  ====================Transactions ====================
    public insertPayAmount(insertamount,): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/transcation', insertamount, { headers: this.headers });
    }

    public getTranscationType(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/transcationtype', { headers: this.headers });
    }
    public transactionId(): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/transcationtype?Receipt=Receipt', { headers: this.headers });
    }
    public getAllAccountTypes(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/account_types', { headers: this.headers });
    }
    public getAllCashierById(store_id: number, role_id: number[]): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/company-users?store_id=' + store_id + '&role_id=' + role_id, { headers: this.headers });
    }


    public getAccountType(account_type_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/account_types?account_type_id=' + account_type_id, { headers: this.headers });
    }
    // ==================== Import Products ====================
    // IMPORT

    public importproduct(array): Observable<any> {

        return this.http.post<any>(this.ecomUrl + '/import-inventory', array, { headers: this.headers });
    }

    //  ====================Actions ====================
    public createAction(actions): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/action', actions, { headers: this.headers });
    }
    public getActionsForAdmin(): Observable<any> {
        return this.http.get<any[]>(this.ecomUrl + '/action', { headers: this.headers });
    }
    public getActionsById(action_id): Observable<any> {
        return this.http.get<any[]>(this.ecomUrl + '/action?action_id=' + action_id, { headers: this.headers });
    }
    public deleteAction(action_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/action/' + action_id, { headers: this.headers })
    }

    public updateActions(action_id, actions): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/action/' + action_id, actions, { headers: this.headers });
    }
    // =====================ROLES WITH PRIVI ACTIONS===================
    public insertRoleWithPriviAction(insertvalues): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/roleprivilegeaction', insertvalues, { headers: this.headers });
    }
    public getRoleWithPrivilegeAction(store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/roleprivilegeaction?store_id=' + store_id, { headers: this.headers });
    }
    public getRoleWithPrivilegeActionForAdmin(role_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/roleprivilegeaction?role_id=' + role_id, { headers: this.headers });
    }
    public deleteRolePrivilegeAction(role_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/roleprivilegeaction?role_id=' + role_id, { headers: this.headers })
    }

    //  ====================Privileges ====================
    public createPrivilage(privilegename): Observable<any[]> {
        return this.http.post<any[]>(this.ecomUrl + '/privilege', privilegename, { headers: this.headers });
    }
    public getPrivilageNameForAdmin(role_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/privilege?role_id=' + role_id, { headers: this.headers });
    }
    public getPrivilegeById(privilege_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/privilege?privilege_id=' + privilege_id, { headers: this.headers });
    }
    public deletePrivileges(privilege_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/privilege/' + privilege_id, { headers: this.headers })
    }

    public updatePrivilege(privilege_id, privilege): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/privilege/' + privilege_id, privilege, { headers: this.headers });
    }
    // MAPPED VALUES
    public getMappedValue(privilege_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/roleprivilege?privilege_id=' + privilege_id, { headers: this.headers });
    }
    // ACTIONMAPPING WITH PRIVILEGES
    public getMappedValuesForAdmin(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/actionprivilege', { headers: this.headers });
    }
    public insertMapedActions(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/actionmapping', data, { headers: this.headers });
    }

    public updateRoleWithPriviAction(values): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/roleprivilegeaction', values, { headers: this.headers });
    }
    public deleteMappedValues(privilege_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/actionprivilege?privilege_id=' + privilege_id, { headers: this.headers })
    }
    public RemapPrivilageActions(): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/remap_privilege_actions', { headers: this.headers });
    }
    // ==================== Roles ====================
    public createRole(insertroles): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/role', insertroles, { headers: this.headers });
    }
    public getRoles(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/role', { headers: this.headers });
    }
    public getRolesForUsers(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/role?user_id=' + this.Data.user_id + '&role_id=' + this.Data.role_id, { headers: this.headers });
    }
    public getRolesForAdmin(role_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/role?role_id=' + role_id, { headers: this.headers });
    }
    public getRolesForLoginHistory(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/role?login=1', { headers: this.headers });
    }
    public deleteRoles(role_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/role/' + role_id, { headers: this.headers });
    }
    // ===================USER=====================
    public userlogin(login): Observable<any> {
        // Authentication -----------------------------
        // Public API, So no need to use header
        // Remove Header
        return this.http.post<any>(this.ecomUrl + '/companyUserlogin', login);
        // return this.http.post<any>(this.ecomUrl + '/userlogin', login);

    }
    public deleteCompanyUsers(company_users_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/companyUser?company_users_id=' + company_users_id, { headers: this.headers });
    }


    public updateCompanyUsers(company_users_id, userrole): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/companyUser/' + company_users_id, userrole, { headers: this.headers });
    }

    public storeUser(user_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/loginstoreuser?user_id=' + user_id, { headers: this.headers });
    }
    public approvedDeliveryBoy(company_users_id, deliveryboy): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/deliveryboy_approvel/' + company_users_id, deliveryboy, { headers: this.headers });
    }
    public changedefaultlocation(pickup_location_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/changepickuplocation?pickup_location_id=' + pickup_location_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public changeOnlineKiosk(kiosk_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/change-online-kiosk?kiosk_id=' + kiosk_id + '&store_id=' + store_id, { headers: this.headers });
    }

    public changeDefaultKOT(kot_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/kot/' + kot_id, { headers: this.headers });
    }
    //  ====================Customer ====================
    public getAccountDetails(account_id, account_type_id): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/getcustomer?account_id=' + account_id + '&account_type_id=' + account_type_id, { headers: this.headers });
    }
    public getCustomerAccountId(cust_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/customers?cust_id=' + cust_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getCustDetails(cust_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/customers?cust_id=' + cust_id, { headers: this.headers });
    }
    public getCustomer(cust_id, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/customer?cust_id=' + cust_id + '&store_id=' + store_id, { headers: this.headers });
    }

    public getCustomerRowCountByStoreID(store_id, from_date, to_date): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/customerreport?customer_rowcount&store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    public getCustomerRowCount(): Observable<number> {
        return this.http.get<number>(this.ecomUrl + '/customerreport?customer_rowcount', { headers: this.headers });
    }


    public getRportForCustomerForUser(store_id, user_id): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/customerreport?store_id=' + store_id + '&user_id=' + user_id, { headers: this.headers });
    }
    // CUSTOMER REPORT WITH STORE ID
    public getCustomerReport(store_id, this_page_first_item, result_per_page, keyword, filter_id): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/customerreport?store_id=' + store_id + '&page_first_result=' + this_page_first_item + '&result_per_page=' + result_per_page + '&keyword=' + keyword + '&filter_id=' + filter_id, { headers: this.headers });
    }

    // public SearchCustomerForAdminCustomerReport(store_id, cust_name): Observable<any[]> {

    //     return this.http.get<any[]>(this.ecomUrl + '/customerreport?store_id=' + store_id + '&cust_name=' + cust_name, { headers: this.headers });
    // }
    public customerEdit(custdata): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/customers', custdata, { headers: this.headers });
    }


    public getCurrentBal(cust_account_id, account_type_id, store_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/getcustomer?account_id=' + cust_account_id + '&account_type_id=' + account_type_id + '&store_id=' + store_id, { headers: this.headers });
    }
    public getDeliveryReports(store_id, from_date, to_date, this_page_first_item, result_per_page): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/deliveryreports?store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + this_page_first_item + '&result_per_page=' + result_per_page, { headers: this.headers });
    }

    // ==========================REFUND==========================



    public searchCustomerByDateInRefund(from_date, to_date, store_id, cust_name): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/refundreport?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id + '&cust_name=' + cust_name, { headers: this.headers });
    }

    // REPORT FOR REFUND WITH STORE ID
    public getRefundReportWithStoreId(store_id, from_date, to_date): Observable<any[]> {

        return this.http.get<any[]>(this.ecomUrl + '/refundreport?store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    //  ====================SALES ON DEALS ====================


    public getSalesOnDealsRowCount(store_id, from_date, to_date): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/saleondeals?sales_rowcount' + '&store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    public getSaleDealbyStoreId(store_id, from_date, to_date, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/saleondeals?store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public getSaleDealbyProductName(store_id, product_name, from_date, to_date): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/saleondeals?store_id=' + store_id + '&product_name=' + product_name + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    //===========================TAX REPORT==============================

    public getTaxReportWithStoreId(store_id, from_date, to_date, account_head_id, this_page_first_item, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/taxreport?store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date + '&account_head_id=' + account_head_id + '&page_first_limit=' + this_page_first_item + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public taxTotalReport(from_date, to_date, store_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/taxreport?from_date=' + from_date + '&to_date=' + to_date + '&store_id=' + store_id, { headers: this.headers });
    }
    //  ====================Points ====================
    public deletePoint(point_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/point_details/' + point_id, { headers: this.headers });
    }
    public updatePoint(point_id, updatepoint): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/point_details/' + point_id, updatepoint, { headers: this.headers });
    }


    // -----------------------------------------------
    //  ====================Banner ====================
    // ------------------------------------------------
    //Banner Details
    public bannerDetails(bannerdetails): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/banner_details', bannerdetails, { headers: this.headers });
    }
    public getAllBannerDetails(store_id, resource_type_id = 0): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/banner_details?store_id=' + store_id + '&banner_type=' + resource_type_id, { headers: this.headers });
    }
    public getAllBannerDetailsByCategoryID(category_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/banner_details?category_id=' + category_id, { headers: this.headers });
    }
    // created by jemi 07-04-2020
    public getAllBannerDetailsByBrandID(brand_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/banner_details?brand_id=' + brand_id, { headers: this.headers });
    }
    public getAllBannerDetailsByBusinessID(business_type_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/banner_details?business_type_id=' + business_type_id, { headers: this.headers });
    }
    public deleteBanner(resource_id): Observable<any> {

        return this.http.delete<any>(this.ecomUrl + '/banner_details/' + resource_id, { headers: this.headers })
    }

    public updateBannerApproval(resource_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/resource/approval/' + resource_id, data, { headers: this.headers });
    }

    public getCompanyBannerDetails(resource_type_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/banner_details?store_id=0&resource_type=' + resource_type_id, { headers: this.headers });
    }

    public mapBanner(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/map-banner', data, { headers: this.headers });
    }

    //  ====================group===========================

    public getReasons(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reasons', { headers: this.headers });
    }
    //Group
    public deleteCustomerGroup(group_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/group/' + group_id, { headers: this.headers })
    }
    public updateGroup(group_id, group): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/group/' + group_id, group, { headers: this.headers });
    }
    //customer group

    // start App Announcement
    public getAppAnnouncement(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/app_announcement', { headers: this.headers });
    }
    public createAppAnnouncement(data): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/app_announcement', data, { headers: this.headers });
    }
    public updateAppAnnouncement(app_announcement_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/app_announcement/' + app_announcement_id, data, { headers: this.headers });
    }
    public deleteAppAnnouncement(app_announcement_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/app_announcement/' + app_announcement_id, { headers: this.headers });
    }
    public deleteImageFromAppAnnouncement(app_announcement_id, resource_id): Observable<any> {

        return this.http.get<any>(this.ecomUrl + '/app_announcement?app_announcement_id=' + app_announcement_id + '&resource_id=' + resource_id, { headers: this.headers });
    }
    // end app announcement
    public createCustomerGroup(customergroup): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/customergroup', customergroup, { headers: this.headers });
    }
    public getCustomerByGroup(group_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/customergroup?group_id=' + group_id, { headers: this.headers });
    }
    // =====================================invoice=============================
    public deleteInvoice(prod_order_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/actualinvoice/' + prod_order_id, { headers: this.headers });
    }
    public getInvoicebyOrderID(prod_order_id): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/actualinvoice?prod_order_id=' + prod_order_id, { headers: this.headers });
    }
    //INVOICE
    public generateInvoice(invoice): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/actualinvoice', invoice, { headers: this.headers });
    }

    // ==========================get notification  08-10-2019=============================
    public SendNotificationFromAdmin(datas) {
        return this.http.post<any>(this.ecomUrl + '/notification', datas, { headers: this.headers })
    }
    public getReferenceTypesforSms(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/reference_type?notification', { headers: this.headers });
    }
    public getStoresByArea(user_id, role_id, area_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store?role_id=' + role_id + '&user_id=' + user_id + '&area_id=' + area_id, { headers: this.headers });
    }
    public getAdminNotifications(notification_type_id, app_type_id, reference_type_id, store_id, query, page_first_result, result_per_page) {
        return this.http.get<any>(this.ecomUrl + '/notification?notification_type_id=' + notification_type_id + '&app_type_id=' + app_type_id + '&reference_type_id=' + reference_type_id + '&store_id=' + store_id + '&query=' + query + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers })
    }

    public sendNotification(store_id, message) {
        return this.http.get<any>(this.ecomUrl + '/notification?message=' + message + '&store_id=' + store_id, { headers: this.headers })
    }
    public getAllNotifications(store_id, page_first_result, result_per_page, searchText): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/notification?user_id=' + this.Data.user_id + '&role_id=' + this.Data.role_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page + '&store_id=' + store_id + '&query=' + searchText, { headers: this.headers });
    }
    public getUnreadNotifications(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/notification?user_id=' + this.Data.user_id + '&role_id=' + this.Data.role_id + '&notification_status_id=' + 5, { headers: this.headers });
    }

    //  ====================Footer Content ====================
    public createFooterContent(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/footer_content', datas, { headers: this.headers });
    }
    public getFooterContent(store_id, reference_type_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/footer_content?reference_type_id=' + reference_type_id + '&store_id=' + store_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public updateFooterContent(footer_content_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/footer_content/' + footer_content_id, data, { headers: this.headers });
    }
    //  ====================FooterLinks====================
    public createFooterLinks(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/footer_links', datas, { headers: this.headers });
    }
    public getFooterLinks(store_id, reference_type_id, page_first_result, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/footer_links?reference_type_id=' + reference_type_id + '&store_id=' + store_id + '&page_first_result=' + page_first_result + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public updateFooterLinks(footer_link_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/footer_links/' + footer_link_id, data, { headers: this.headers });
    }
    //  ====================SLAB SETTINGS====================
    public createSlabSettings(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/slab_settings', datas, { headers: this.headers });
    }
    public getSlabSettings(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/slab_settings', { headers: this.headers });
    }
    public getSlabSettingsById(delivery_partner_id, slab_type_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/slab_settings?delivery_partner_id=' + delivery_partner_id + '&slab_type_id=' + slab_type_id, { headers: this.headers });
    }
    public updateSlabSettings(slab_setting_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/slab_settings/' + slab_setting_id, data, { headers: this.headers });
    }
    public deleteSlabSettings(slab_setting_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/slab_settings/' + slab_setting_id, { headers: this.headers });
    }
    //  ====================SURGES====================
    // =======================Agent Commissions========================
    public createAgentCommissions(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/agent-commission', datas, { headers: this.headers });
    }
    public getAgentCommissions(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/agent-commission', { headers: this.headers });
    }
    public updateAgentCommission(agent_commission_id, data): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/agent-commission/' + agent_commission_id, data, { headers: this.headers });
    }
    public deleteAgentCommission(agent_commission_id): Observable<any> {
        return this.http.delete<any>(this.ecomUrl + '/agent-commission/' + agent_commission_id, { headers: this.headers });
    }
    // ========================= SURGE=====================
    public createSurges(datas): Observable<any> {
        return this.http.post<any>(this.ecomUrl + '/surges', datas, { headers: this.headers });
    }
    public getSurges(): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/surges', { headers: this.headers });
    }

    // ========================= STORE PAYOUT=====================
    public getStorePayout(store_id, from_date, to_date): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store_payout?store_id=' + store_id + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    public getTotalStorePayout(store_id, from_date, to_date): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/store_payout?store_id=' + store_id + '&total=' + 1 + '&from_date=' + from_date + '&to_date=' + to_date, { headers: this.headers });
    }
    // ========================= DELIVERY PARTNER PAYOUT=====================
    public getDeliveryPartnerPayOut(delivery_partner_id): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/delivery_partner_payout?delivery_partner_id=' + delivery_partner_id, { headers: this.headers });
    }
    public userReviewStatus(user_rating_id, review_status): Observable<any> {
        return this.http.put<any>(this.ecomUrl + '/user_rating/' + user_rating_id, review_status, { headers: this.headers });
    }
    public getProducts(type): Observable<Product[]> {
        return this.http.get<Product[]>(this.url + type + '-products.json');
    }

    public getProductById(id): Observable<Product> {
        return this.http.get<Product>(this.url + 'product-' + id + '.json');
    }

    public getBanners(): Observable<any[]> {
        return this.http.get<any[]>(this.url + 'banners.json');
    }
    public getImageByStoreID(store_id, this_page_first_item, result_per_page): Observable<any[]> {
        return this.http.get<any[]>(this.ecomUrl + '/not-existing-product-images?store_id=' + store_id + '&page_first_result=' + this_page_first_item + '&result_per_page=' + result_per_page, { headers: this.headers });
    }
    public searchProduct(filter: { name: string } = { name: '' }): Observable<any> {
        return this.http.get<any>(this.ecomUrl + '/product?product_name=' + name, { headers: this.headers })
    }
    public getDays() {
        return [
            { name: 'Monday' },
            { name: 'Tuesday' },
            { name: 'Wednesday' },
            { name: 'Thursday' },
            { name: 'Friday' },
            { name: 'Saturday' },
            { name: 'Sunday' }
        ];
    }

    public getHours() {
        return [
            { value: '0' },
            { value: '01' },
            { value: '02' },
            { value: '03' },
            { value: '04' },
            { value: '05' },
            { value: '06' },
            { value: '07' },
            { value: '08' },
            { value: '09' },
            { value: '10' },
            { value: '11' },
            { value: '12' }
        ]
    }

    public getMinutes() {
        return [
            { minute: '00' },
            { minute: '01' },
            { minute: '02' },
            { minute: '03' },
            { minute: '04' },
            { minute: '05' },
            { minute: '06' },
            { minute: '07' },
            { minute: '08' },
            { minute: '09' },
            { minute: '10' },
            { minute: '11' },
            { minute: '12' },
            { minute: '13' },
            { minute: '14' },
            { minute: '15' },
            { minute: '16' },
            { minute: '17' },
            { minute: '18' },
            { minute: '19' },
            { minute: '20' },
            { minute: '21' },
            { minute: '22' },
            { minute: '23' },
            { minute: '24' },
            { minute: '25' },
            { minute: '26' },
            { minute: '27' },
            { minute: '28' },
            { minute: '29' },
            { minute: '30' },
            { minute: '31' },
            { minute: '32' },
            { minute: '33' },
            { minute: '34' },
            { minute: '35' },
            { minute: '36' },
            { minute: '37' },
            { minute: '38' },
            { minute: '39' },
            { minute: '40' },
            { minute: '41' },
            { minute: '42' },
            { minute: '43' },
            { minute: '44' },
            { minute: '45' },
            { minute: '46' },
            { minute: '47' },
            { minute: '48' },
            { minute: '49' },
            { minute: '50' },
            { minute: '51' },
            { minute: '52' },
            { minute: '53' },
            { minute: '54' },
            { minute: '55' },
            { minute: '56' },
            { minute: '57' },
            { minute: '58' },
            { minute: '59' }
        ]
    }

    public getYears() {
        return ["2024", "2025", "2026", "2027", "2028", "2029", "2030"]
    }
}